export default __webpack_public_path__ + "static/media/stop.643d530d.png";